import React, { PureComponent } from 'react'
import { Grid, TableRow, TableCell, MenuItem } from '@material-ui/core'
import { EditableTextField, EditableSelect } from '../common/EditableComponents'

class PaymentProviders extends PureComponent {
  render() {
    const { partner = {}, provider = {}, editMode } = this.props

    return (
      <TableRow>
        <TableCell>
          <EditableTextField value={partner.name} valueToRender={partner.name} editMode={false} />
        </TableCell>
        <TableCell>
          <Grid xs={12} sm={6} md={6} lg={6}>
            <EditableSelect
              valueToRender={provider.paymentProvider}
              editMode={editMode}
              value={provider.paymentProvider}
              onChange={(e) => this.props.onChange('paymentProvider', e.target.value)}
            >
              {partner.availablePaymentOptions.map((item, index) => {
                return (
                  <MenuItem key={index} value={item}>
                    {item}
                  </MenuItem>
                )
              })}
            </EditableSelect>
          </Grid>
        </TableCell>
      </TableRow>
    )
  }
}

export default PaymentProviders



// WEBPACK FOOTER //
// ./src/components/PaymentProviders/index.js